import React from 'react';
import { ArrowRight } from 'react-feather';
interface NavItemProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  isMobile?: boolean;
}
export function NavItem({
  label,
  isActive,
  onClick,
  isMobile = false
}: NavItemProps) {
  return <button onClick={onClick} className={`group text-left text-[1.1rem] md:text-fluid-lg md:text-[clamp(1.333rem,2vw,1.777rem)] tracking-tight 
        inline-flex items-center gap-1.5 hover:translate-x-2 transition-all duration-300
        ${isActive ? 'text-white' : 'text-[#7A8290] hover:text-white'}`} data-id="element-101">
      {label}
      <span className={`inline-flex items-center w-6 transition-all duration-300 ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} aria-hidden="true" data-id="element-102">
        <ArrowRight size={18} strokeWidth={2} data-id="element-103" />
      </span>
    </button>;
}